export default "__VITE_ASSET__3a04ba24__"